import { Injectable } from '@angular/core';
import { CatalogNode, OccCatalogParams } from '@catalog/const/v2';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { CatalogActions } from '../store/actions';
import { CatalogData, StateWithCatalog } from '../store/catalog-state';
import { CatalogSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class CatalogFacade {
  constructor(private store: Store<StateWithCatalog>) {}

  loadNode({ nodeId, level }: OccCatalogParams): void {
    combineLatest({
      node: this.store.pipe(select(CatalogSelectors.getCatalogNode(nodeId))),
      isLoading: this.store.pipe(select(CatalogSelectors.getCatalogLoading)),
    })
      .pipe(
        take(1),
        tap(({ node, isLoading }) => {
          if (!node && !isLoading) {
            this.store.dispatch(new CatalogActions.CatalogLoad({ nodeId, level }));
          }
        }),
      )
      .subscribe();
  }

  getNode(nodeId: string): Observable<CatalogNode | undefined> {
    return this.store.pipe(select(CatalogSelectors.getCatalogNode(nodeId)));
  }

  getNodes(): Observable<CatalogData> {
    return this.store.select(CatalogSelectors.getCatalogValue);
  }

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(CatalogSelectors.getCatalogLoading));
  }

  getSuccess(): Observable<boolean> {
    return this.store.pipe(select(CatalogSelectors.getCatalogSuccess));
  }

  getError(): Observable<boolean> {
    return this.store.pipe(select(CatalogSelectors.getCatalogError));
  }
}
